import axios from 'axios'
import JSZip from 'jszip'
import FileSaver from 'file-saver'

export async function getFile (url) {
    return await new Promise(async function(resolve, reject) {
        await axios({
            method:'get',
            url,
            responseType: 'arraybuffer'
        }).then(data => {
            resolve(data.data)
        }).catch(error => {
            reject(error.toString())
        })
    })
}

export async function downLoad(data,fileName){
    const zip = new JSZip()
    const promises = []
    let nameMap ={};
    for(let i = 0 ; i<data.length; i++){
        let item = data[i];
        promises.push(await getFile(item.url).then(data => { // 下载文件, 并存成ArrayBuffer对象
            let name = "";
            if(nameMap[item.name] ==null){
                nameMap[item.name] = 1;
                name = item.name
            }else{
                nameMap[item.name] = Number(nameMap[item.name])+1;
                name = item.name.split(".")[0] +"(" +nameMap[item.name] +")." + item.name.split(".")[1];
            }
            zip.file(name, data, { binary: true }) // 逐个添加文件
        }))
    }
    Promise.all(promises).then(() => {
        zip.generateAsync({type:"blob"}).then(content => { // 生成二进制流
            FileSaver.saveAs(content, fileName) // 利用file-saver保存文件
        })
    })
}



// WEBPACK FOOTER //
// ./src/utils/downLoadModel.js